module.exports = {
	"version": "1.2442.24",
	"manifest": {
		"a11yTestKit": "1.2396.57",
		"adminLoginButton": "1.2442.20",
		"animations": "1.2396.57",
		"audioCommon": "1.2396.57",
		"audioPlayer": "1.2442.20",
		"backToTopButton": "1.2442.20",
		"backgroundCommon": "1.2442.20",
		"balata": "1.2442.20",
		"bgImageStrip": "1.2442.20",
		"boxSlideShowSlide": "1.2442.20",
		"buttonCommon": "1.2396.57",
		"checkbox": "1.2442.20",
		"column": "1.2224.7",
		"comboBoxInput": "1.2442.20",
		"compDesignUtils": "1.2293.8",
		"compUtils": "1.2442.24",
		"components": "1.2442.20",
		"componentsPreviewLayer": "1.2442.20",
		"contactForm": "1.2442.20",
		"container": "1.2442.20",
		"containerCommon": "1.2396.57",
		"core": "1.2442.24",
		"coreUtils": "1.2442.20",
		"dataFixer": "1.2442.24",
		"datePicker": "1.2442.20",
		"dateUtils": "1.2224.7",
		"deadComponent": "1.2442.20",
		"dialogs": "1.2442.20",
		"displayer": "1.2442.20",
		"disqusComments": "1.2442.20",
		"documentMedia": "1.2442.20",
		"documentServices": "1.2442.24",
		"documentServicesSchemas": "1.2442.20",
		"editingRendererPlugins": "1.2224.7",
		"exitMobileModeButton": "1.2442.20",
		"facebookComments": "1.2442.20",
		"facebookLike": "1.2442.20",
		"facebookLikeBox": "1.2442.20",
		"facebookShare": "1.2442.20",
		"fileUploader": "1.2442.20",
		"flashComponent": "1.2442.20",
		"flickrBadgeWidget": "1.2442.20",
		"fonts": "1.2396.57",
		"fontsPrefetch": "1.2224.7",
		"formCommon": "1.2442.20",
		"galleriesCommon": "1.2335.3",
		"googleMap": "1.2442.20",
		"gridComponent": "1.2442.20",
		"groupContainer": "1.2442.20",
		"hoverBox": "1.2224.7",
		"htmlComponent": "1.2442.20",
		"image": "1.2442.20",
		"imageButton": "1.2442.20",
		"imageClientApi": "1.2224.7",
		"imageCommon": "1.2396.57",
		"imageZoom": "1.2442.20",
		"imageZoomDisplayer": "1.2442.20",
		"internalMarkings": "1.2326.5",
		"itunesButton": "1.2442.20",
		"languageSelector": "1.2442.20",
		"layout": "1.2442.24",
		"linkBar": "1.2442.20",
		"loggingUtils": "1.2442.20",
		"loginButton": "1.2442.20",
		"loginSocialBar": "1.2442.20",
		"matrixGallery": "1.2442.20",
		"mediaCommon": "1.2442.20",
		"mediaContainerFactory": "1.2367.7",
		"mediaControls": "1.2442.20",
		"mediaPlayer": "1.2442.20",
		"mediaZoom": "1.2442.20",
		"memoizeAPI": "1.2350.4",
		"menuButton": "1.2442.20",
		"messageView": "1.2442.20",
		"mobileActionsMenu": "1.2442.20",
		"multilingual": "1.2442.20",
		"page": "1.2442.20",
		"paypalButton": "1.2442.20",
		"pinItPinWidget": "1.2442.20",
		"pinterestFollow": "1.2442.20",
		"pinterestPinIt": "1.2442.20",
		"popupCloseTextButton": "1.2442.20",
		"popupContainer": "1.2442.20",
		"previewExtensionsCore": "1.2224.7",
		"qaAutomation": "1.2335.3",
		"quickActionBar": "1.2442.20",
		"quickActionBarItem": "1.2442.20",
		"radioButton": "1.2442.20",
		"radioGroup": "1.2442.20",
		"render": "1.2442.20",
		"repeater": "1.2442.20",
		"rssButton": "1.2442.20",
		"santaPreview": "1.2326.5",
		"santaProps": "1.2442.24",
		"singleAudioPlayer": "1.2442.20",
		"siteBackground": "1.2396.57",
		"siteRegionContainer": "1.2442.20",
		"siteUtils": "1.2442.20",
		"skinExports": "1.2442.20",
		"skins": "1.2442.20",
		"skypeCallButton": "1.2442.20",
		"slideShowGallery": "1.2442.20",
		"socialCommon": "1.2350.4",
		"soundCloudWidget": "1.2442.20",
		"spotifyFollow": "1.2442.20",
		"spotifyPlayer": "1.2442.20",
		"stripColumnsContainer": "1.2442.20",
		"stripContainer": "1.2442.20",
		"stripSlideShow": "1.2442.20",
		"stripSlideShowSlide": "1.2442.20",
		"subscribeForm": "1.2442.20",
		"svgCommon": "1.2442.20",
		"svgShape": "1.2442.20",
		"table": "1.2442.20",
		"testUtils": "1.2442.20",
		"textArea": "1.2442.20",
		"textCommon": "1.2442.20",
		"tinyMenu": "1.2442.20",
		"tpa": "1.2442.20",
		"tpaGalleries": "1.2442.20",
		"translationsUtils": "1.2350.4",
		"tweenEngine": "1.2224.7",
		"twitterFeed": "1.2442.20",
		"utils": "1.2442.24",
		"vKShareButton": "1.2442.20",
		"verticalAnchorsMenu": "1.2442.20",
		"verticalMenu": "1.2442.20",
		"wGooglePlusOne": "1.2442.20",
		"wTwitterFollow": "1.2442.20",
		"wTwitterTweet": "1.2442.20",
		"warmup": "1.2442.24",
		"widgets": "1.2442.20",
		"wixCode": "1.2442.20",
		"wixCodeInit": "1.2442.20",
		"wixCodeSeo": "1.2442.20",
		"wixSites": "1.2396.57",
		"wixappsBuilder": "1.2396.57",
		"wixappsClassics": "1.2442.20",
		"wixappsCore": "1.2442.20",
		"youTubeSubscribeButton": "1.2442.20",
		"zoomedImage": "1.2442.20"
	},
	"versions": {
		"mobx": "3.1.0",
		"mobxReact": "4.1.8",
		"lodash": "4.17.4/dist",
		"react": "0.14.3",
		"tweenmax": "1.19.0",
		"pmrpc": "1.30.0"
	},
	"packages": [
		"a11yTestKit",
		"adminLoginButton",
		"animations",
		"audioCommon",
		"audioPlayer",
		"backToTopButton",
		"backgroundCommon",
		"balata",
		"bgImageStrip",
		"boxSlideShowSlide",
		"buttonCommon",
		"checkbox",
		"column",
		"comboBoxInput",
		"compDesignUtils",
		"compUtils",
		"components",
		"componentsPreviewLayer",
		"contactForm",
		"container",
		"containerCommon",
		"core",
		"coreUtils",
		"dataFixer",
		"datePicker",
		"dateUtils",
		"deadComponent",
		"dialogs",
		"displayer",
		"disqusComments",
		"documentMedia",
		"documentServices",
		"documentServicesSchemas",
		"editingRendererPlugins",
		"exitMobileModeButton",
		"facebookComments",
		"facebookLike",
		"facebookLikeBox",
		"facebookShare",
		"fileUploader",
		"flashComponent",
		"flickrBadgeWidget",
		"fonts",
		"fontsPrefetch",
		"formCommon",
		"galleriesCommon",
		"googleMap",
		"gridComponent",
		"groupContainer",
		"hoverBox",
		"htmlComponent",
		"image",
		"imageButton",
		"imageClientApi",
		"imageCommon",
		"imageZoom",
		"imageZoomDisplayer",
		"internalMarkings",
		"itunesButton",
		"languageSelector",
		"layout",
		"linkBar",
		"loggingUtils",
		"loginButton",
		"loginSocialBar",
		"matrixGallery",
		"mediaCommon",
		"mediaContainerFactory",
		"mediaControls",
		"mediaPlayer",
		"mediaZoom",
		"memoizeAPI",
		"menuButton",
		"messageView",
		"mobileActionsMenu",
		"multilingual",
		"page",
		"paypalButton",
		"pinItPinWidget",
		"pinterestFollow",
		"pinterestPinIt",
		"popupCloseTextButton",
		"popupContainer",
		"previewExtensionsCore",
		"qaAutomation",
		"quickActionBar",
		"quickActionBarItem",
		"radioButton",
		"radioGroup",
		"render",
		"repeater",
		"rssButton",
		"santaPreview",
		"santaProps",
		"singleAudioPlayer",
		"siteBackground",
		"siteRegionContainer",
		"siteUtils",
		"skinExports",
		"skins",
		"skypeCallButton",
		"slideShowGallery",
		"socialCommon",
		"soundCloudWidget",
		"spotifyFollow",
		"spotifyPlayer",
		"stripColumnsContainer",
		"stripContainer",
		"stripSlideShow",
		"stripSlideShowSlide",
		"subscribeForm",
		"svgCommon",
		"svgShape",
		"table",
		"testUtils",
		"textArea",
		"textCommon",
		"tinyMenu",
		"tpa",
		"tpaGalleries",
		"translationsUtils",
		"tweenEngine",
		"twitterFeed",
		"utils",
		"vKShareButton",
		"verticalAnchorsMenu",
		"verticalMenu",
		"wGooglePlusOne",
		"wTwitterFollow",
		"wTwitterTweet",
		"warmup",
		"widgets",
		"wixCode",
		"wixCodeInit",
		"wixCodeSeo",
		"wixSites",
		"wixappsBuilder",
		"wixappsClassics",
		"wixappsCore",
		"youTubeSubscribeButton",
		"zoomedImage"
	]
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/santa-main-r/src/main/options/viewer.json
// module id = 28
// module chunks = 0